import React, {FC, useState} from 'react'
import {useField} from 'formik'
import {useIntl} from 'react-intl'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import CreatableSelect from 'react-select/creatable'
import {colourStyles} from '../../styles/styles'
import {Calendar} from 'primereact/calendar'

const Step2: FC = () => {
  const intl = useIntl()

  //constantes que recebem os valores do formulário
  const [fieldStartdate, metaStartdate] = useField('start_date')
  const [fieldLimitdate, metaLimitdate] = useField('limit_date')
  const [fieldConclusiondate, ,] = useField('conclusion_date')
  const [fieldStatus, metaStatus] = useField('status')

  const [fieldAlertDays, metaAlertDays, helperAlertDays] = useField('alert_days')

  const [selectedAlertDays, setSelectedAlertDays] = useState<number[]>(fieldAlertDays.value)

  const handleInputChangeRenovationAlertDays = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(parseInt(event[i].value))
      }
    }
    setSelectedAlertDays(event)
    helperAlertDays.setValue(inputValue)
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='pb-10 pb-lg-12'>
          <h2 className='fw-bolder text-dark'>{intl.formatMessage({id: 'PROVIDENCE.STEP2'})}</h2>

          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'PROVIDENCE.STEP2SUB'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            {/* input de data de início */}
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.START_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  selectionMode='single'
                  inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  {...fieldStartdate}
                />
                {metaStartdate.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaStartdate.error}</div>
                ) : null}
              </div>
            </div>

            {/* input de data limite */}
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  selectionMode='single'
                  inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  {...fieldLimitdate}
                />
                {metaLimitdate.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaLimitdate.error}</div>
                ) : null}
              </div>
            </div>
          </div>
          {/* inicio da segunda linha */}

          {/* input de data de conclusão */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  selectionMode='single'
                  inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  {...fieldConclusiondate}
                />
              </div>
            </div>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'CONTRACT_RENEWAL_NOTICE'})}
              </label>
              <div className='d-flex position-relative my-1'>
                <CreatableSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1'
                  styles={colourStyles}
                  isMulti
                  placeholder='Quant. de dias'
                  {...fieldAlertDays}
                  value={selectedAlertDays}
                  onChange={handleInputChangeRenovationAlertDays}
                />
                {metaAlertDays.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaAlertDays.error}</div>
                ) : null}
              </div>
            </div>
          </div>
          {/* fim da segunda linha */}
          <div className='row mt-3'>
            {/* input de status */}
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.STATUS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...fieldStatus}
                >
                  <option></option>
                  <option value='not_started'>
                    {intl.formatMessage({id: 'COMMON.NOT_STARTED'})}
                  </option>
                  <option value='in_progress'>
                    {intl.formatMessage({id: 'COMMON.IN_PROGRESS'})}
                  </option>
                  <option value='expired'>{intl.formatMessage({id: 'COMMON.EXPIRED'})}</option>
                  <option value='canceled'>{intl.formatMessage({id: 'COMMON.CANCELED'})}</option>
                  <option value='done'>{intl.formatMessage({id: 'CONDITIONINGS.STATUS_3'})}</option>
                </select>
                {metaStatus.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaStatus.error}</div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
